import { useRef } from "react";
import SmartLink from "../fragments/SmartLink";
import Image from "../fragments/Image";
import { useReveal } from '../hooks/UseReveal';

export default function Thumbnail({ post, limitHeight = false, newsPage = false }) {

    const revealRef = useReveal({ once: true });

    return (

        <SmartLink 
            link={`${post.permalink}`} 
            className={`c-thumbnail ${newsPage ? 'c-thumbnail--news' : ''}`}
        >
            <div className="c-thumbnail__inner c-transition-in" ref={revealRef}> 
                {post.thumbnail && (
                    <div className="c-thumbnail__image">
                        {limitHeight === false ? (
                            <Image 
                                src={post.thumbnail.src}
                                alt={post.thumbnail.alt || ''}
                                width={post.thumbnail.width}
                                height={post.thumbnail.height}
                            />
                        ) : (
                            <Image 
                                src={post.thumbnail.src}
                                alt={post.thumbnail.alt || ''}
                                width={644}
                                height={414}
                            />
                        )}
                    </div>
                )}
                <div className="c-thumbnail__content">
                    <h3 className="c-thumbnail__title">{post.title}</h3>
                    {newsPage && (
                        <p className="c-thumbnail__date">{post.date}</p>
                    )}
                    {!newsPage && (
                        <div className="c-thumbnail__tags c-tags">
                            {post.location && post.location.length > 0 && 
                                <>
                                    {post.location.map((loc, idx) => (
                                        <span className="c-tags__tag" key={idx}>{loc.text}</span>
                                    ))}
                                </>
                            }
                            {post.category && post.category.length > 0 && 
                                <>
                                    {post.category.map((cat, idx) => (
                                        <span className="c-tags__tag" key={idx}>{cat.text}</span>
                                    ))}
                                </>
                            }
                        </div>
                    )}
                </div>
            </div>
        </SmartLink>

    )
}